import propType from 'prop-types';
import React, { useRef } from 'react';
import ReadingTimeIndicator from '../ReadingTimeIndicator';

export default function DetailBody({ content, readingTime }) {
  const contentRef = useRef();

  return (
    <div ref={contentRef} className="article-content">
      <ReadingTimeIndicator
        contentRef={contentRef}
        readingTime={readingTime || 0}
      />
      <div
        className="article-content__wp"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
}

DetailBody.propTypes = {
  content: propType.node.isRequired,
  readingTime: propType.number.isRequired
};
